module.exports = __webpack_public_path__ + "img/q&a12.f1da5514.png";